import { DateTime } from "luxon";

export { isMultiDayDate } from "@simplyk/common";

export const getDate = (date: Date | number) => {
  return typeof date === "number" ? DateTime.fromMillis(date) : DateTime.fromJSDate(date);
};

export const getDateInTimezone = (date: Date | number, timezone?: string | null) => {
  const dt = typeof date === "number" ? DateTime.fromMillis(date) : DateTime.fromJSDate(date);
  return timezone ? dt.setZone(timezone) : dt;
};

export const shouldDisplayYear = (luxonDate: DateTime, now: DateTime | null = null) => {
  const luxonNow = now ?? DateTime.now();

  const threeMonthsFromNow = luxonNow.plus({ months: 3 });

  const isPast = luxonDate < luxonNow;
  const isMoreThanThreeMonthsAway = luxonDate > threeMonthsFromNow;
  const isDifferentYear = luxonDate.year !== luxonNow.year;

  return isPast || (isMoreThanThreeMonthsAway && isDifferentYear);
};

export const formatShortDate = (luxonDate: DateTime, isoLocale: string, luxonNow: DateTime): string => {
  return luxonDate.toLocaleString(
    {
      month: "short",
      day: "numeric",
      year: shouldDisplayYear(luxonDate, luxonNow) ? "numeric" : undefined,
    },
    { locale: isoLocale }
  );
};

// Formats a DateTime with time and timezone abbreviation (e.g., "7:00 PM EST")
export const formatTimeWithTimezone = (luxonDate: DateTime, isoLocale: string): string => {
  const timeString = luxonDate.toLocaleString({ hour: "numeric", minute: "2-digit" }, { locale: isoLocale });
  const localizedDate = luxonDate.reconfigure({ locale: isoLocale });
  const timezoneAbbr = localizedDate.offsetNameShort || localizedDate.toFormat("ZZZZ");
  return `${timeString} ${timezoneAbbr}`;
};
